import { Button, ButtonGroup, Icon, Intent, Popover, Size } from "@blueprintjs/core"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, ITableRCell, ITableRow, LANDING_TYPE_CONTENT, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../utils/updateSection"

/* Protopia Ecosystem component */
export interface ITableCellEditorProps {
    section: ILandingSection
    table: TableContent
    cell: ITableRCell
    children: any
}
const TableCellEditor = (props: ITableCellEditorProps): JSX.Element => {
    const isEdit : boolean = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit )

    const onChange = (val: any, field: string, dop: any="") => { 
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    return {
                        ...props.table,
                        data:props.table.data.map(row => {
                            if(!!row.cells.find(cell => cell.id === props.cell.id)) {
                                const cells = row.cells
                                    .filter(cell => {
                                        if(field === "colSpan") {
                                            return true
                                        }
                                        return true
                                    })
                                    .map(cell => {
                                        if(cell.id === props.cell.id) {
                                            const newCell = {
                                                ...props.cell,
                                                [field]: val
                                            }
                                            return newCell
                                        }
                                        return cell
                                    })
                                return {
                                    ...row, 
                                    cells: cells 
                                }
                            }
                            return row
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Change table cell's " + field
        }
        updateSection( data, historyStep )
    }
    const onCollapse = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    return {
                        ...props.table,
                        data:props.table.data.map(row => {
                            if(!!row.cells.find(cell => cell.id === props.cell.id)) {
                                const cells = row.cells.filter(cell => cell.id !== props.cell.id)
                                return {
                                    ...row, 
                                    cells: cells 
                                }
                            }
                            return row
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Collapse table's cell"
        }
        updateSection( data, historyStep )
    }
    const onHorBreak = () => {

    }
    const onVerBreak = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    let columnOrder: number = -1, 
                        rowOrder: number= -1, 
                        rowSpan: number  = 0, 
                        bCell: ITableRCell = {id: getID("cell"), text: ""} as ITableRCell
                    const table: TableContent = {
                        ...props.table,
                        data: props.table.data.map((row, n) => {
                            if(!!row.cells.find(cell => cell.id === props.cell.id)) {
                                const cells = row.cells.map((cell, i) => {
                                    if(cell.id === props.cell.id) {
                                        columnOrder = i;
                                        rowOrder = n;
                                        bCell = { ...cell }
                                        rowSpan = cell.rowSpan || 0
                                        return {
                                            ...cell,
                                            rowSpan: undefined
                                        }
                                    } 
                                    return cell 
                                })

                                return {
                                    ...row, 
                                    cells: cells 
                                }
                            }
                            if( !rowSpan ) {
                                
                            }
                            else if( n > columnOrder && n < columnOrder + rowSpan ) { 
                                row.cells.splice( columnOrder, 0, { ...bCell, rowSpan: undefined, id: getID("cell") } )
                            }
                            return row
                        })
                    }
                    if( !rowSpan ) {
                        let newRow: ITableRow = {...table.data[ rowOrder ], id: getID(`cell`), cells:[{...bCell}] }
                        let oldRow : ITableRow = {...table.data[ rowOrder ] }
                        oldRow = {
                            ...oldRow, 
                            cells: oldRow.cells.map(cell => {
                                
                                console.log( cell )

                                if(cell.id === props.cell.id) {
                                    return cell
                                }
                                return {
                                    ...cell,
                                    rowSpan: !cell.rowSpan || cell.rowSpan === 1 ? 2 : cell.rowSpan + 1,
                                    text: cell.text 
                                }
                            })
                        }
                        
                        console.log( rowOrder, oldRow, )
                        
                        table.data.splice( rowOrder, 1, oldRow, newRow )
                    }
                    return table
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Table's cell vertical break "
        }
        updateSection( data, historyStep ) 
    }
    const onAdd = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.table.id ) {
                    return {
                        ...props.table,
                        data:props.table.data.map(row => {
                            if(!!row.cells.find(cell =>  cell.id === props.cell.id)) {
                                const cells = row.cells 
                                const order = cells.findIndex( cell =>  cell.id === props.cell.id )
                                cells.splice( order + 1, 0, { ...row.cells[ order ], id: getID( "cell" ), } )
                                return {
                                    ...row, 
                                    cells: cells 
                                }
                            }
                            return row
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Add table's cell"
        }
        updateSection( data, historyStep )
    }
    return <>
        {props.children}
        { 
            isEdit && <div className="landing-table-cell-editor pe-surface pe-item-editor z-index-100" data-select-type="ignore" > 
                <Popover
                    position="bottom-right"
                    // interactionKind="hover"
                    content={
                        <ButtonGroup vertical alignText="left">
                            <Button
                                className="edit-menu-btn"
                                icon={ "edit" }
                                size={ Size.SMALL }
                                text={__("Edit")}
                            /> 
                            <button
                                className="edit-menu-btn d-flex w-100 align-items-center " 
                                style={{height: 24, marginBottom:0 }}  
                            > 
                                <Icon icon={ "color-fill" } />
                                <span className="bp5-button-text pl-3 mr-auto opacity_75 letter-spacing-2">{__("Fill")}</span>
                                <span className="flex-grow-100" />
                                <Popover
                                    interactionKind="hover"
                                    content={
                                        <div className="pe-panel-container position-relative px-3 py-1">
                                            <FieldInput
                                                type={SCALAR_TYPES.COLOR}
                                                value={ props.cell.bg }
                                                editable
                                                field="bg"
                                                onChange={onChange}
                                                notClear
                                            />
                                        </div>
                                    }
                                >
                                    <div 
                                        className={`pe-color-picker-example-small `} 
                                        style={{ backgroundColor: props.cell.bg || "#FFF" }} 
                                    /> 
                                </Popover>
                            </button>
                            <button
                                className="edit-menu-btn d-flex w-100 align-items-center " 
                                style={{height: 24, marginBottom:0 }}  
                            > 
                                <Icon icon={ "tint" } />
                                <span className="bp5-button-text pl-3 mr-auto opacity_75 letter-spacing-2">{__("Text color")}</span>
                                <span className="flex-grow-100" />
                                <Popover
                                    interactionKind="hover"
                                    content={
                                        <div className="pe-panel-container position-relative px-3 py-1">
                                            <FieldInput
                                                type={SCALAR_TYPES.COLOR}
                                                value={ props.cell.color }
                                                editable
                                                field="color"
                                                onChange={onChange}
                                                notClear
                                            />
                                        </div>
                                    }
                                >
                                    <div 
                                        className={`pe-color-picker-example-small `} 
                                        style={{ backgroundColor: props.cell.color || "#FFF" }} 
                                    /> 
                                </Popover>
                            </button> 
                            <button
                                className="edit-menu-btn d-flex w-100 align-items-center " 
                                style={{height: 24, marginBottom:0 }}  
                            > 
                                <Icon icon={ "small-square" } />
                                <span className="bp5-button-text pl-3 mr-auto opacity_75 letter-spacing-2">{__("Border")}</span>
                                <span className="flex-grow-100" />
                                <Popover
                                    interactionKind="hover"
                                    content={
                                        <div className="pe-panel-container position-relative px-3 py-1">
                                            <FieldInput
                                                type={SCALAR_TYPES.BORDER}
                                                value={ props.cell.border } 
                                                editable
                                                field="border"
                                                onChange={onChange}
                                                notClear
                                            />
                                        </div>
                                    }
                                >
                                    <div className={`pe-color-picker-example-small `} /> 
                                </Popover>
                            </button> 
                            <button
                                className="edit-menu-btn d-flex w-100 align-items-center " 
                                style={{height: 24, marginBottom:0 }}  
                            > 
                                <Icon icon={ "add-column-right" } />
                                <span className="bp5-button-text pl-3 mr-auto opacity_75 letter-spacing-2">{__("Columns span")}</span>
                                <span className="flex-grow-100" />
                                <Popover
                                    interactionKind="hover"
                                    content={
                                        <div className=" position-relative px-3 py-1">
                                            <FieldInput
                                                type={SCALAR_TYPES.NUMBER}
                                                value={ props.cell.colSpan || 1 }
                                                min={0}
                                                editable
                                                field="colSpan"
                                                onChange={onChange}
                                                notClear
                                            />
                                        </div>
                                    }
                                >
                                    <div className={`pe-color-picker-example-small flex-center smaller`} >
                                        {props.cell.colSpan || 0}
                                    </div> 
                                </Popover>
                            </button> 
                            <button
                                className="edit-menu-btn d-flex w-100 align-items-center " 
                                style={{height: 24, marginBottom:0 }}  
                            > 
                                <Icon icon={ "add-row-bottom" } />
                                <span className="bp5-button-text pl-3 mr-auto opacity_5 letter-spacing-2">{__("Rows span")}</span>
                                <span className="flex-grow-100" />
                                <Popover
                                    interactionKind="hover"
                                    content={
                                        <div className=" position-relative px-3 py-1">
                                            <FieldInput
                                                type={SCALAR_TYPES.NUMBER}
                                                value={ props.cell.rowSpan || 1 }
                                                min={0}
                                                editable
                                                field="rowSpan"
                                                onChange={onChange}
                                                notClear
                                            />
                                        </div>
                                    }
                                >
                                    <div className={`pe-color-picker-example-small flex-center smaller`} >
                                        {props.cell.rowSpan || 0}
                                    </div> 
                                </Popover>
                            </button> {/* */}
                            <Button
                                className="edit-menu-btn"
                                icon={ "add-column-right" }
                                size={ Size.SMALL }
                                text={__("Horizontal break")}
                                onClick={onHorBreak}
                            /> 
                            <Button
                                className="edit-menu-btn"
                                icon={ "add-row-bottom" }
                                size={ Size.SMALL }
                                text={__("Vertical break")}
                                onClick={onVerBreak}
                            /> 
                            <Button
                                className="edit-menu-btn"
                                icon={ "plus" }
                                size={ Size.SMALL }
                                text={__("Add new cell after")}
                                onClick={onAdd}
                            /> 
                            <Button
                                className="edit-menu-btn danger"
                                icon="trash" 
                                intent={ Intent.DANGER }
                                size={ Size.SMALL }
                                text={__("Collapse cell")}
                                onClick={onCollapse}
                            />  
                        </ButtonGroup>
                    }
                >
                    <Button
                        className="edit-menu-btn"
                        icon="caret-down"
                        size={ Size.SMALL }
                    />
                </Popover>  
            </div>
        }
    </>
}
export default TableCellEditor